import React from "react";
import { Button, Chip, TextField } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import { Autocomplete } from "@material-ui/lab";
import SelectMenu from "../Utility/SelectMenu";
import RenderDatePicker from "../Utility/RenderDatePicker";
import "../style.css";
import FinancialYearDropdown from "../Utility/FinancialYearDropdown";
const HistoryFilter = (props) => {
  return (
    <>
      <>
        <div class="filter-main-div">
          <div className="gstr2a2bnew-datepicker-container">
            <RenderDatePicker
              flag={"multipleMonths"}
              selectedFromDateRP={props.selectedFromDateRP}
              selectedToDateRP={props.selectedToDateRP}
              setSelectedToDateRP={props.setSelectedToDateRP}
              setSelectedFromDateRP={props.setSelectedFromDateRP}
            />
          </div>
          {/* <div className="gstr2a2bnew-datepicker-container">
          <RenderDatePicker
              flag={"singleYear"}
              selectedFromDateRP={props.selectedFromDateRP}
              selectedToDateRP={props.selectedToDateRP}
              setSelectedToDateRP={props.setSelectedToDateRP}
              setSelectedFromDateRP={props.setSelectedFromDateRP}
            />
          </div> */}
          <div
            style={{ width: "32%", marginLeft: "1.6em", marginTop: "0.4em" }}
            className="gstr2a2bDatePicker"
          >
            <FinancialYearDropdown
              handleChange={props.handleSelectedYear}
              selectedYear={props.selectedYear}
            />
          </div>
        </div>
        <div className="filter-chips-background">
          <div style={{ display: "flex" }}>
            <div className="filter-chips-heading">Taxpayer GSTIN</div>
            <div className="filter-chips-background-div">
              {props.gstinTaxpayerFilter.map((gstin, i) => (
                <Chip
                  className="filter-chips"
                  label={gstin}
                  clickable
                  color="primary"
                  onDelete={() => {
                    props.handleChipDelete(i, "gstin");
                  }}
                />
              ))}
            </div>
          </div>
          <div style={{ display: "flex" }} className="filter-text-input">
            <FormControl fullWidth variant="filled" style={{ width: "40%" }}>
              <label for="filled-adornment-amount" className="filter-label">
                Taxpayer GSTIN
              </label>

              <Autocomplete
                {...props.defaultPropsTaxGstins}
                id="auto-complete"
                value={props.taxpayerGstin}
                onChange={(event, newValue) => {
                  props.onChangeTaxpayerGstin(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    // margin="normal"
                    style={{ backgroundColor: "#eaeaea" }}
                  />
                )}
              />
            </FormControl>
            <Button
              onClick={props.handleAddTaxpayerGstin}
              className="filter-add-button"
            >
              + Add
            </Button>
          </div>
        </div>

        <div className="filter-chips-background ">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className="filter-dropdown-label">Fetch Status</div>
            <div className="filter-dropdown-label">Report Type</div>
          </div>
          <div
            style={{ display: "flex", justifyContent: "space-between" }}
            className="filter-text-input"
          >
            <div
              className="dropdown-container-gstr2a2bnew document-type-filter"
              style={{ width: "40%" }}
            >
              <SelectMenu
                options={props.fetchStatusList}
                selectedValue={props.fetchStatusFilter}
                handleChange={(e) => props.handleFetchStatusFilterChange(e)}
              />
            </div>
            <div
              className="dropdown-container-gstr2a2bnew document-type-filter"
              style={{ width: "40%" }}
            >
              <SelectMenu
                options={props.reportTypeList}
                selectedValue={props.reportTypeFilter}
                handleChange={(e) => props.handleReportTypeFilterChange(e)}
              />
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default HistoryFilter;
